import { ApplicationState } from '../../reducers'
import { HubCallback } from '@aws-amplify/core/lib/Hub'
import { registerForNotifications } from '../../services/notifications'
import { Hub } from '@aws-amplify/core'
import { signIn, signOut } from './actions'
import { loadEvents } from '../global/status'
import { getCurrentUser } from '../../utilities/account'
import { getUserUsername, getFavDealsForUser, getUserAttribute } from './utilities'

const configureAccountListener = () =>
    async (dispatch: any, getState: () => ApplicationState) => {
        const user = await getCurrentUser()
        const username = await getUserUsername(user)
        const email = await getUserAttribute(user, 'email')
        const favDeals = await getFavDealsForUser(username)
        const listener: HubCallback = (data) => {
            switch (data.payload.event) {
                case 'signIn':
                    dispatch(signIn({
                        username,
                        email,
                        favDeals,
                    }))
                    registerForNotifications()
                    break
                case 'signOut':
                    dispatch(signOut())
                    break
                case 'cognitoHostedUI':
                    dispatch(loadEvents())
                    break
            }
        }

        Hub.listen('auth', listener)

        try {
            await getCurrentUser()
            dispatch(signIn({
                username,
                email,
                favDeals,
            }))
            registerForNotifications()
        } catch (error) {
            dispatch(signOut())
        }
    }

export { configureAccountListener }
